<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <div class="container">
      <div class="steps-content">
        <div class="general-form-wrap videos-info-wrap box-wrapper">
          <div class="videos-form-wrap">
            <div class="heading">
              <h2 class="form-title">Videos ( Up to 12 )</h2>
            </div>
            <p class="description">Youtube Or Vimeo Only</p>
            <div class="videos-list">
              <div
                class="video-detail"
                v-for="(video, index) in videoList"
                :key="index"
              >
                <a-row :gutter="24">
                  <a-col :sm="4" :md="3">
                    <div class="title-info">Video {{ index + 1 }}</div>
                  </a-col>
                  <a-col :sm="5" :md="4">
                    <a-input
                      v-model="video.videoDesc"
                      placeholder="Video Title"
                    />
                  </a-col>
                  <a-col :sm="15" :md="9">
                    <a-input
                      v-model="video.videoUrl"
                      placeholder="Video Link"
                    />
                  </a-col>
                  <a-col :sm="24" :md="7">
                    <div class="button-wrap">
                      <span
                        v-if="video.videoDesc !== '' && video.videoUrl !== ''"
                      >
                        <a-popconfirm
                          title="Sure you want to delete this video?"
                          @confirm="removeVideo(video)"
                          ok-text="Yes"
                          cancel-text="No"
                        >
                          <a-button type="danger" icon="delete"
                            >Delete</a-button
                          >
                        </a-popconfirm>
                      </span>
                      <span v-if="video.id === null">
                        <a-button
                          type="primary"
                          icon="file-add"
                          class="save-button"
                          v-on:click="addNewVideo(video)"
                          >Save</a-button
                        >
                      </span>
                      <span v-else>
                        <a-button
                          type="primary"
                          icon="file-add"
                          class="save-button"
                          v-on:click="editVideo(video)"
                          >Save</a-button
                        >
                      </span>
                      <span
                        v-if="video.videoDesc !== '' && video.videoUrl !== ''"
                      >
                        <a-button type="primary" @click="showModal(index)"
                          >Preview</a-button
                        >
                      </span>
                    </div>
                  </a-col>
                </a-row>
                <VideoModal
                  :url="video.videoUrl"
                  :visible="visibleList[index] && visibleList[index].visible"
                  @onModalClose="closeModal"
                  v-if="videoList.length !== 1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoModal from "./VideoModal";
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "../../../../../repositories/RepositoryFactory";
import { Base } from "@/models";
const athleteRepository = RepositoryFactory.get("athlete");
const ATHLETE_STORE_KEY = "athleteStore";
const STORE_KEY = "playerStore";

export default {
  name: "VideoInfo",
  props: ["id"],
  components: {
    VideoModal
  },
  data() {
    return {
      datalength: 0,
      visibleList: [],
      videoList: [
        {
          id: null,
          videoDesc: "",
          videoUrl: ""
        }
      ]
    };
  },
  mounted() {
    this.getVideoList();
  },
  computed: {
    ...mapGetters({
      athleteVideos: `${ATHLETE_STORE_KEY}/athleteVideos`
    }),
    profileId() {
      return Base.profileId() || this.profileId;
    }
  },
  methods: {
    ...mapActions({
      addPlayerVideos: `${STORE_KEY}/addPlayerVideos`,
      setProfileData: `${STORE_KEY}/setViewProfileData`
    }),
    async getVideoList() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, {
        athleteId: this.profileId,
        limit: 12,
        page: 1
      });
      this.visibleList = this.athleteVideos.map(item => ({ visible: false }));
      this.videoList =
        this.athleteVideos.length === 12
          ? this.athleteVideos
          : [
              ...this.athleteVideos,
              {
                id: null,
                videoDesc: "",
                videoUrl: ""
              }
            ];
    },
    addNewVideo(video) {
      let toSend = {
        atheleteMainProfileId: this.profileId,
        videoDesc: video.videoDesc,
        videoUrl: video.videoUrl,
        slug: "athletevideo"
      };
      athleteRepository
        .postPlayerVideos(toSend)
        .then(async response => {
          this.$message.success("Video added successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, {
            athleteId: this.profileId,
            limit: 12,
            page: 1
          });
        })
        .catch(error => {
          this.$notification.error({
            message: "Error",
            description: "Plese Input A Valid Link"
          });
        });
    },
    editVideo(video) {
      let toSend = {
        videoDesc: video.videoDesc,
        videoUrl: video.videoUrl,
        slug: "athletevideo"
      };
      athleteRepository
        .editPlayerVideos(toSend, video.id)
        .then(async response => {
          this.$message.success("Video updated successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, {
            athleteId: this.profileId,
            limit: 12,
            page: 1
          });
        })
        .catch(error => {
          this.$notification.error({
            message: "Error",
            description: "Plese Input A Valid Link"
          });
        });
    },
    removeVideo(video) {
      athleteRepository
        .deletePlayerVideos(video.id, {
          slug: "athletevideo"
        })
        .then(async response => {
          this.$message.success("Video deleted successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, {
            athleteId: this.profileId,
            limit: 12,
            page: 1
          });
        });
    },
    showModal(index) {
      this.visibleList[index].visible = true;
    },
    closeModal() {
      for (let i = 0; i < this.videoList.length + 1; i++) {
        this.visibleList[i].visible = false;
      }
    }
  },
  watch: {
    athleteVideos(newVal, _) {
      this.visibleList = newVal.map(item => ({ visible: false }));
      this.videoList =
        newVal.length === 12
          ? newVal
          : [
              ...newVal,
              {
                id: null,
                videoDesc: "",
                videoUrl: ""
              }
            ];
    }
  }
};
</script>
<style lang="scss">
.videos-form-wrap {
  .heading {
    margin-bottom: 10px;
  }
  .description {
    font-size: 14px;
    font-weight: 400;
    color: #797979;
    margin-bottom: 40px !important;
  }
  .videos-list {
    .video-detail {
      margin-bottom: 20px;
      .title-info {
        font-size: 14px;
        text-transform: uppercase;
        line-height: 40px;
        font-weight: 500;
        color: #000000;
      }
      .button-wrap {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .ant-btn-danger {
          line-height: 40px;
          height: 40px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .videos-form-wrap {
    .videos-list {
      .video-detail {
        .button-wrap {
          > span {
            margin-right: 10px;
            &:last-child {
              margin-right: 0;
            }
          }
          .ant-btn {
            > .anticon {
              + span {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .videos-form-wrap {
    .videos-list {
      .video-detail {
        margin-bottom: 30px;
        .title-info {
          font-size: 12px;
          line-height: 40px;
        }
        .button-wrap {
          margin-top: 10px;
          justify-content: flex-end;
          .ant-btn {
            font-size: 12px;
            height: 36px;
            line-height: 36px;
            > .anticon {
              + span {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .videos-form-wrap {
    .description {
      margin-bottom: 20px !important;
    }
    .videos-list {
      .video-detail {
        margin-bottom: 30px;
        .ant-input {
          margin-bottom: 10px;
          text-align: center;
          font-size: 12px;
          height: 36px !important;
        }
        .title-info {
          font-size: 14px;
          text-align: center;
          line-height: 40px;
        }
        .button-wrap {
          margin-top: 0px;
          justify-content: center;
        }
      }
    }
  }
}
</style>
